module.exports = __webpack_public_path__ + "img/2_11_1.3025b68e.jpg";